import { useAtomValue } from "jotai";
import type { FocusEvent, KeyboardEvent } from "react";
import { canv } from "@/canv/global";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { renameDocument } from "../../lib/renameDocument";
import type { SetActiveSubMenu } from "../../types";
import styles from "./DocumentRenameInput.module.css";

interface DocumentReNameInputProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function DocumentReNameInput({ setActiveSubMenu }: DocumentReNameInputProps) {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("documentName"));

    const handleInputFocus = () => {
        setActiveSubMenu(null);
        canv.appInterface.inputFocused = 1;
    };

    const handleInputBlur = (event: FocusEvent<HTMLInputElement>) => {
        canv.appInterface.inputFocused = 0;
        renameDocument(event.currentTarget.value, canv);
    };

    const handleInputKeydown = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            event.preventDefault();
            event.currentTarget.blur();
        }
    };

    return (
        <input
            className={styles.input}
            type="text"
            defaultValue={options[0].value as string}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            onKeyDown={handleInputKeydown}
        />
    );
}
